/**
 * Shared "Mute notifications" state (AffiliateUsers.ReceiveNotifications) between the bell drawer
 * and Notifications → Preferences. muted === !receiveNotifications.
 * After a successful save, call emitNotificationPreferenceChanged so every open toggle updates at once.
 */

const PREFERENCE_CHANGED_EVENT = 'affiliate-notification-preference-changed';

// Last known mute state, read by ToastContext so success/info/warning toasts stay silent while muted.
let mutedCache = false;
export const isNotificationsMuted = () => mutedCache;

/** API result → muted flag (missing value = not muted, matching the DB default ReceiveNotifications = 1). */
export function isMutedFromPreferences(data) {
  const value = data?.receiveNotifications ?? data?.ReceiveNotifications;
  mutedCache = value === false;
  return mutedCache;
}

export function emitNotificationPreferenceChanged(muted) {
  mutedCache = Boolean(muted);
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(PREFERENCE_CHANGED_EVENT, { detail: { muted: Boolean(muted) } }));
}

/** Subscribe to preference changes; returns an unsubscribe function. */
export function onNotificationPreferenceChanged(handler) {
  if (typeof window === 'undefined') return () => {};
  const listener = (e) => handler(Boolean(e?.detail?.muted));
  window.addEventListener(PREFERENCE_CHANGED_EVENT, listener);
  return () => window.removeEventListener(PREFERENCE_CHANGED_EVENT, listener);
}
